import appConfig from '@/app.config';

const baseUrl = appConfig.melissaRootUrl;

const getMelissaAddresses = (
  melissaAddress1,
  melissaCountry,
) => fetch(
  `${baseUrl}/GlobalExpressAddress?format=${appConfig.melissaApiFormat}&id=${appConfig.melissaApiLicenseKey}&address1=${melissaAddress1}&locality=
  &administrativearea=&country=${melissaCountry}&maxrecords=${appConfig.melissaApiMaxRecord}&MinLength=${appConfig.melissaApiMinLength}`,
).then((response) => response.json());

export default {
  getMelissaAddresses,
};
